// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%270 0 12 12%27%3E%3Cpath fill=%27%236b7280%27 d=%27M6 8L1 3h10z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== Page Layout ===== */
.my-meetings-page {
  max-width: 1400px;
  margin: 0 auto;
}

.page-header {
  margin-bottom: 28px;
}

.header-top {
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
}

.page-header h2 {
  font-size: 28px;
  color: #1a1a2e;
  margin: 0;
  font-weight: 700;
}

.total-badge {
  background: #e8f0fe;
  color: #0066cc;
  font-size: 13px;
  font-weight: 600;
  padding: 4px 12px;
  border-radius: 20px;
}

.page-header p {
  color: #6b7280;
  margin: 6px 0 0 0;
  font-size: 15px;
}

/* ===== Error Banner ===== */
.error-banner {
  background: #fef2f2;
  border: 1px solid #fecaca;
  color: #b91c1c;
  padding: 14px 18px;
  border-radius: 10px;
  margin-bottom: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
}

.error-banner button {
  background: none;
  border: none;
  color: #b91c1c;
  cursor: pointer;
  font-size: 18px;
  padding: 0 4px;
}

/* ===== Summary Row ===== */
.summary-row {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  margin-bottom: 28px;
}

.summary-card {
  background: #fff;
  border-radius: 12px;
  padding: 20px 24px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.06);
  border-left: 4px solid transparent;
  transition: transform 0.15s, box-shadow 0.15s;
}

.summary-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}

.summary-active  { border-left-color: #0066cc; }
.summary-success { border-left-color: #16a34a; }
.summary-fail    { border-left-color: #dc2626; }
.summary-spam    { border-left-color: #7c3aed; }

.summary-num {
  font-size: 32px;
  font-weight: 700;
  color: #1a1a2e;
  line-height: 1;
}

.summary-label {
  font-size: 13px;
  color: #6b7280;
  margin-top: 4px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* ===== Tabs ===== */
.tabs {
  display: flex;
  gap: 8px;
  margin-bottom: 24px;
  border-bottom: 2px solid #e5e7eb;
  padding-bottom: 0;
}

.tab-btn {
  padding: 12px 20px;
  background: transparent;
  border: none;
  border-bottom: 3px solid transparent;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  color: #6b7280;
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: -2px;
}

.tab-btn:hover {
  color: #374151;
  border-bottom-color: #d1d5db;
}

.tab-btn.active {
  color: #0066cc;
  border-bottom-color: #0066cc;
}

.tab-count {
  background: #e5e7eb;
  color: #374151;
  font-size: 12px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 10px;
  min-width: 20px;
  text-align: center;
}

.tab-btn.active .tab-count {
  background: #dbeafe;
  color: #0066cc;
}

.tab-btn.tab-spam.active {
  color: #7c3aed;
  border-bottom-color: #7c3aed;
}

.tab-btn.tab-spam.active .tab-count {
  background: #ede9fe;
  color: #6d28d9;
}

/* ===== Loading ===== */
.loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 60px 20px;
  color: #6b7280;
  font-size: 15px;
}

.loading-spinner-ring {
  width: 36px;
  height: 36px;
  border: 3px solid #e5e7eb;
  border-top-color: #0066cc;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* ===== Empty State ===== */
.empty-state {
  text-align: center;
  padding: 72px 20px;
  background: #f9fafb;
  border-radius: 16px;
  border: 2px dashed #e5e7eb;
}

.empty-icon {
  margin-bottom: 16px;
}

.empty-icon svg {
  width: 52px;
  height: 52px;
}

.empty-state h3 {
  margin: 0 0 8px 0;
  color: #1a1a2e;
  font-size: 18px;
}

.empty-state p {
  color: #6b7280;
  margin: 0;
  font-size: 14px;
}

/* ===== Card List ===== */
.cards-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

/* ===== Meeting Card ===== */
.meeting-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.05);
  overflow: hidden;
  transition: box-shadow 0.2s, border-color 0.15s;
  border: 1px solid #e5e7eb;
}

.meeting-card:hover {
  box-shadow: 0 3px 12px rgba(0,0,0,0.07);
}

.meeting-card.card-open {
  border-color: #93c5fd;
  box-shadow: 0 2px 12px rgba(0,102,204,0.1);
}

.meeting-card.card-completed {
  opacity: 0.75;
  border-color: #d1d5db;
}

.meeting-card.card-spam {
  border-color: #c4b5fd;
  background: #faf5ff;
}

/* Clickable area */
.card-clickable {
  cursor: pointer;
  transition: background 0.1s;
}

.card-clickable:hover {
  background: #f9fafb;
}

/* Card Header */
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 18px 4px;
}

.card-header-left {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.expand-arrow {
  color: #9ca3af;
  font-size: 12px;
  flex-shrink: 0;
  width: 14px;
}

.expand-arrow svg {
  width: 14px;
  height: 14px;
}

.card-id {
  font-weight: 700;
  color: #0066cc;
  font-size: 14px;
  flex-shrink: 0;
}

.card-name {
  font-weight: 600;
  color: #1a1a2e;
  font-size: 14px;
  white-space: nowrap;
}

.card-subject-inline {
  color: #6b7280;
  font-size: 13px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
}

.card-header-right {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
}

.card-date {
  color: #9ca3af;
  font-size: 12px;
}

.card-assigned-date {
  color: #6366f1;
  font-size: 12px;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.card-assigned-date svg,
.status-badge svg,
.chip svg {
  width: 14px;
  height: 14px;
  flex-shrink: 0;
}

.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 14px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.3px;
}

.badge-not_started {
  background: #f0f1f2;
  color: #6c757d;
}

.badge-in_progress {
  background: #dbeafe;
  color: #1d4ed8;
}

.badge-completed {
  background: #dcfce7;
  color: #16a34a;
}

.badge-spam {
  background: #ede9fe;
  color: #6d28d9;
}

/* Contact details (in expanded panel) */
.contact-details-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 12px 24px;
}

.contact-link {
  color: #0066cc;
  text-decoration: none;
  font-size: 13px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: color 0.15s;
}

.contact-link:hover {
  color: #004999;
  text-decoration: underline;
}

.contact-location {
  font-size: 13px;
  color: #6b7280;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.contact-icon {
  font-size: 14px;
  width: 18px;
  text-align: center;
  flex-shrink: 0;
}

.expanded-contact-row {
  margin-bottom: 0;
}

/* Chips Row */
.card-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding: 4px 18px 12px 42px;
}

.chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 12px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 500;
}

.chip-success {
  background: #dcfce7;
  color: #166534;
}

.chip-danger {
  background: #fef2f2;
  color: #991b1b;
}

.chip-neutral {
  background: #f3f4f6;
  color: #6b7280;
}

.chip-amount {
  background: #ecfdf5;
  color: #047857;
  font-weight: 600;
}

.chip-rejection {
  background: #fef3c7;
  color: #92400e;
}

.chip-notes {
  background: #ede9fe;
  color: #5b21b6;
}

.chip-clickable {
  cursor: pointer;
  transition: opacity 0.15s;
}

.chip-clickable:hover {
  opacity: 0.8;
}

/* ===== Expanded Panel ===== */
.card-expanded {
  border-top: 1px solid #e5e7eb;
  background: #f9fafb;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  animation: expandIn 0.15s ease;
}

@keyframes expandIn {
  from { opacity: 0; max-height: 0; }
  to   { opacity: 1; max-height: 2000px; }
}

/* Actions row (Contacted / Deal / Order Status) */
.expanded-actions-row {
  display: flex;
  gap: 24px;
  flex-wrap: nowrap;
  padding: 16px 20px;
  background: #fff;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
}

.action-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 140px;
}

.action-group-wide {
  flex: 1 0 auto;
  min-width: 370px;
}

.action-group-return {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: auto;
}

.lead-actions-group {
  min-width: max-content;
}

.lead-actions-row {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: nowrap;
}

.return-btn {
  padding: 7px 18px;
  border: 1px solid #f59e0b;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s;
  background: #fffbeb;
  color: #92400e;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.return-btn:hover:not(:disabled) {
  background: #fef3c7;
  border-color: #d97706;
}

.return-btn:disabled {
  opacity: 0.5;
  cursor: default;
}

.reactivate-btn {
  padding: 7px 18px;
  border: 1px solid #3b82f6;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s;
  background: #eff6ff;
  color: #1e40af;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.reactivate-btn:hover:not(:disabled) {
  background: #dbeafe;
  border-color: #2563eb;
}

.reactivate-btn:disabled {
  opacity: 0.5;
  cursor: default;
}

.spam-btn,
.restore-spam-btn {
  padding: 7px 18px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.spam-btn {
  border: 1px solid #8b5cf6;
  background: #faf5ff;
  color: #6d28d9;
}

.spam-btn:hover:not(:disabled) {
  background: #ede9fe;
  border-color: #7c3aed;
}

.restore-spam-btn {
  border: 1px solid #3b82f6;
  background: #eff6ff;
  color: #1e40af;
}

.restore-spam-btn:hover:not(:disabled) {
  background: #dbeafe;
  border-color: #2563eb;
}

.spam-btn:disabled,
.restore-spam-btn:disabled {
  opacity: 0.5;
  cursor: default;
}

.edit-rejection-btn {
  background: none;
  border: none;
  color: #991b1b;
  font-size: 12px;
  cursor: pointer;
  margin-left: 8px;
  padding: 2px 6px;
  border-radius: 4px;
  transition: background 0.15s;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.edit-rejection-btn:hover {
  background: #fecaca;
}

.edit-deal-amount-btn {
  background: none;
  border: none;
  color: #166534;
  font-size: 12px;
  cursor: pointer;
  margin-left: 8px;
  padding: 2px 6px;
  border-radius: 4px;
  transition: background 0.15s;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.edit-rejection-btn svg,
.edit-deal-amount-btn svg {
  width: 12px;
  height: 12px;
}

.edit-deal-amount-btn:hover {
  background: #bbf7d0;
}

.action-label {
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #6b7280;
}

/* Toggles (Yes/No) */
.toggle-group {
  display: flex;
  gap: 0;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #d1d5db;
  width: fit-content;
}

.toggle-btn {
  padding: 7px 18px;
  border: none;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s;
  background: #fff;
  color: #6b7280;
}

.toggle-btn + .toggle-btn {
  border-left: 1px solid #d1d5db;
}

.toggle-yes.active {
  background: #16a34a;
  color: #fff;
}

.toggle-no.active {
  background: #dc2626;
  color: #fff;
}

.toggle-btn:hover:not(:disabled):not(.active) {
  background: #f3f4f6;
}

.toggle-btn:disabled {
  opacity: 0.5;
  cursor: default;
}

/* Order Status Pills */
.order-status-picker {
  position: relative;
}

.order-pills {
  display: flex;
  gap: 8px;
  flex-wrap: nowrap;
}

.order-pill {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 7px 16px;
  border: 1px solid #d1d5db;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s;
  background: #fff;
  color: #6b7280;
}

.pill-icon {
  width: 12px;
  height: 12px;
}

.order-pill:hover:not(:disabled):not(.active) {
  background: #f3f4f6;
  border-color: #9ca3af;
}

.order-pill.active.pill-not_started {
  background: #6c757d;
  border-color: #6c757d;
  color: #fff;
}

.order-pill.active.pill-in_progress {
  background: #0066cc;
  border-color: #0066cc;
  color: #fff;
}

.order-pill.active.pill-completed {
  background: #16a34a;
  border-color: #16a34a;
  color: #fff;
}

.order-pill:disabled {
  opacity: 0.5;
  cursor: default;
}

/* Validation toast */
.validation-toast {
  margin-top: 10px;
  background: #dc2626;
  color: #fff;
  padding: 8px 14px;
  border-radius: 8px;
  font-size: 12px;
  line-height: 1.4;
  animation: slideDown 0.2s ease;
}

@keyframes slideDown {
  from { opacity: 0; transform: translateY(-6px); }
  to   { opacity: 1; transform: translateY(0); }
}

/* Row 2: Contact Info (full width, same as actions row above) */
.contact-sidebar-row {
  margin-bottom: 20px;
}

.contact-sidebar-row .detail-panel {
  width: 100%;
}

/* Row 3: Details row (Message + Notes, 2 columns) */
.expanded-details-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

@media (max-width: 768px) {
  .expanded-details-row {
    grid-template-columns: 1fr;
  }
}

.detail-panel {
  background: #fff;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  padding: 20px;
}

.detail-panel h4 {
  margin: 0 0 14px 0;
  color: #1a1a2e;
  font-size: 14px;
  font-weight: 600;
}

.message-full {
  background: #f9fafb;
  padding: 16px;
  border-radius: 10px;
  border: 1px solid #e5e7eb;
  min-height: 80px;
  white-space: pre-wrap;
  word-break: break-word;
  font-size: 14px;
  line-height: 1.6;
  color: #374151;
}

.message-full table {
  border-collapse: collapse;
  margin: 10px 0;
  width: auto;
  background: white;
}

.message-full table th,
.message-full table td {
  border: 1px solid #ddd;
  padding: 8px 12px;
  text-align: left;
}

.message-full table th {
  background-color: #f5f5f5;
  font-weight: 600;
  color: #333;
}

.message-full table tr:nth-child(even) {
  background-color: #fafafa;
}

.notes-textarea {
  width: 100%;
  min-height: 140px;
  padding: 14px;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  font-size: 14px;
  font-family: inherit;
  resize: vertical;
  transition: border-color 0.2s, box-shadow 0.2s;
  box-sizing: border-box;
  color: #374151;
  line-height: 1.6;
}

.notes-textarea:focus {
  outline: none;
  border-color: #0066cc;
  box-shadow: 0 0 0 3px rgba(0,102,204,0.1);
}

.notes-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 12px;
}

.save-notes-btn {
  padding: 9px 20px;
  background: #16a34a;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.save-notes-btn svg {
  width: 15px;
  height: 15px;
}

.save-notes-btn:hover:not(:disabled) {
  background: #15803d;
}

.save-notes-btn:disabled {
  background: #d1d5db;
  color: #9ca3af;
  cursor: not-allowed;
}

/* Extra panels (rejection / deal amount) */
.expanded-extra-row {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
}

.extra-panel {
  background: #fff;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  padding: 20px;
  flex: 1 1;
  min-width: 240px;
}

.extra-panel h4 {
  margin: 0 0 12px 0;
  font-size: 14px;
  font-weight: 600;
  color: #1a1a2e;
}

.rejection-panel {
  border-color: #fecaca;
  background: #fffbfb;
}

.rejection-info-box {
  background: #fef2f2;
  padding: 14px;
  border-radius: 10px;
  border: 1px solid #fecaca;
}

/* Email source info box */
.email-source-info-box {
  background: #eff6ff;
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid #bfdbfe;
  margin-bottom: 12px;
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-size: 12px;
  line-height: 1.5;
}

.email-source-info-box .info-icon {
  font-size: 14px;
  flex-shrink: 0;
}

.email-source-info-box .info-text {
  color: #1e40af;
  font-size: 11px;
}

.rejection-label {
  color: #991b1b;
  font-weight: 500;
  font-size: 14px;
}

.rejection-comment-text {
  margin-top: 8px;
  font-size: 13px;
  color: #6b7280;
  font-style: italic;
  line-height: 1.4;
}

.deal-panel {
  border-color: #bbf7d0;
  background: #f0fdf4;
}

.deal-amount-display {
  font-size: 22px;
  font-weight: 700;
  color: #16a34a;
  background: #dcfce7;
  padding: 10px 20px;
  border-radius: 10px;
  display: inline-block;
}

/* ===== Modals ===== */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  animation: fadeIn 0.15s ease;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to   { opacity: 1; }
}

.modal-content {
  background: white;
  padding: 36px;
  border-radius: 16px;
  max-width: 480px;
  width: 92%;
  text-align: center;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
  animation: modalSlide 0.2s ease;
}

@keyframes modalSlide {
  from { opacity: 0; transform: translateY(16px) scale(0.97); }
  to   { opacity: 1; transform: translateY(0) scale(1); }
}

.modal-icon {
  margin-bottom: 16px;
}

.modal-icon svg {
  width: 48px;
  height: 48px;
}

.modal-content h3 {
  margin: 0 0 12px 0;
  color: #1a1a2e;
  font-size: 20px;
  font-weight: 600;
}

.modal-content p {
  margin: 0 0 20px 0;
  color: #6b7280;
  font-size: 14px;
}

.rejection-options {
  display: flex;
  flex-direction: column;
  gap: 8px;
  text-align: left;
  width: 100%;
  margin-bottom: 16px;
}

.rejection-option {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  box-sizing: border-box;
  cursor: pointer;
  font-size: 14px;
  line-height: 1.4;
  transition: all 0.15s;
}

.rejection-option:hover {
  background: #f9fafb;
}

.rejection-option.selected {
  border-color: #dc2626;
  background: #fef2f2;
}

.my-meetings-page .rejection-option input[type="radio"] {
  flex: 0 0 16px;
  width: 16px;
  height: 16px;
  padding: 0;
  margin: 0;
  border-radius: 50%;
  accent-color: #dc2626;
  cursor: pointer;
}

.rejection-comment-input {
  width: 100%;
  min-height: 80px;
  padding: 12px;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  font-size: 14px;
  font-family: inherit;
  resize: vertical;
  box-sizing: border-box;
  margin-bottom: 16px;
}

.rejection-comment-input:focus {
  outline: none;
  border-color: #dc2626;
  box-shadow: 0 0 0 3px rgba(220,38,38,0.1);
}

.modal-actions {
  display: flex;
  gap: 12px;
  justify-content: center;
  margin-top: 8px;
}

.modal-btn {
  padding: 11px 28px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s;
  border: none;
}

.modal-btn.cancel {
  background: #f3f4f6;
  color: #6b7280;
  border: 1px solid #e5e7eb;
}

.modal-btn.cancel:hover {
  background: #e5e7eb;
}

.modal-btn.confirm {
  background: #dc2626;
  color: white;
}

.modal-btn.confirm:hover {
  background: #b91c1c;
}

.modal-btn.confirm.confirm-green {
  background: #16a34a;
}

.modal-btn.confirm.confirm-green:hover {
  background: #15803d;
}

.modal-btn.confirm.confirm-orange {
  background: #d97706;
}

.modal-btn.confirm.confirm-orange:hover {
  background: #b45309;
}

.modal-btn.confirm.confirm-blue {
  background: #2563eb;
}

.modal-btn.confirm.confirm-blue:hover {
  background: #1d4ed8;
}

.modal-btn.confirm.confirm-spam {
  background: #7c3aed;
}

.modal-btn.confirm.confirm-spam:hover {
  background: #6d28d9;
}

.modal-hint {
  font-size: 13px;
  color: #9ca3af;
  margin: -12px 0 12px 0;
}

.modal-btn.confirm:disabled {
  background: #d1d5db;
  color: #9ca3af;
  cursor: not-allowed;
}

.deal-amount-input-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: center;
  margin: 20px 0;
}

.deal-amount-input {
  padding: 12px 18px;
  border: 2px solid #d1d5db;
  border-radius: 10px;
  font-size: 20px;
  width: 200px;
  text-align: right;
  transition: border-color 0.15s;
}

.deal-amount-input:focus {
  outline: none;
  border-color: #16a34a;
  box-shadow: 0 0 0 3px rgba(22,163,74,0.1);
}

.deal-amount-currency {
  font-size: 18px;
  font-weight: 600;
  color: #6b7280;
}

/* ===== Reactivate Modal Enhanced Styles ===== */
.modal-content-wide {
  max-width: 520px;
}

.reactivate-edit-section {
  text-align: left;
  background: #f8fafc;
  border-radius: 12px;
  padding: 16px 20px;
  margin: 16px 0;
  border: 1px solid #e2e8f0;
}

.reactivate-edit-label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: #475569;
  margin-bottom: 10px;
}

.reactivate-edit-section .deal-amount-input-wrapper {
  justify-content: flex-start;
  margin: 0;
}

.rejection-reason-select-wrapper {
  position: relative;
}

.rejection-reason-select {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  font-size: 14px;
  font-family: inherit;
  background: white;
  cursor: pointer;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 14px center;
}

.rejection-reason-select:focus {
  outline: none;
  border-color: #dc2626;
  box-shadow: 0 0 0 3px rgba(220,38,38,0.1);
}

.rejection-comment-wrapper {
  margin-top: 12px;
}

.rejection-comment-textarea {
  width: 100%;
  min-height: 80px;
  padding: 12px;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  font-size: 14px;
  font-family: inherit;
  resize: vertical;
  box-sizing: border-box;
}

.rejection-comment-textarea:focus {
  outline: none;
  border-color: #dc2626;
  box-shadow: 0 0 0 3px rgba(220,38,38,0.1);
}

/* ===== Responsive ===== */
@media (max-width: 768px) {
  .my-meetings-page {
    padding: 12px;
  }

  .page-header h2 {
    font-size: 22px;
  }

  .summary-row {
    grid-template-columns: 1fr;
    gap: 10px;
  }

  .summary-card {
    padding: 14px 18px;
  }

  .summary-num {
    font-size: 24px;
  }

  .tabs {
    flex-direction: column;
    gap: 4px;
    border-bottom: none;
  }

  .tab-btn {
    border-bottom: none;
    border-left: 3px solid transparent;
    border-radius: 8px;
    margin-bottom: 0;
    padding: 10px 16px;
  }

  .tab-btn.active {
    background: #eff6ff;
    border-left-color: #0066cc;
  }

  .tab-btn.tab-spam.active {
    background: #faf5ff;
    border-left-color: #7c3aed;
  }

  .card-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    padding: 12px 14px 4px;
  }

  .card-header-left {
    flex-wrap: wrap;
  }

  .card-subject-inline {
    display: none;
  }

  .card-chips {
    padding: 4px 14px 10px 14px;
  }

  .card-expanded {
    padding: 18px;
  }

  .expanded-actions-row {
    flex-direction: column;
    gap: 16px;
    padding: 14px 16px;
  }

  .action-group-wide {
    min-width: unset;
  }

  .expanded-details-row {
    grid-template-columns: 1fr;
  }

  .expanded-extra-row {
    flex-direction: column;
  }

  .extra-panel {
    min-width: unset;
  }

  .modal-content {
    padding: 24px;
    width: 95%;
  }
}

@media (max-width: 480px) {
  .order-pills {
    flex-direction: column;
  }

  .order-pill {
    text-align: center;
    justify-content: center;
  }

  .toggle-btn {
    padding: 7px 14px;
    font-size: 12px;
  }
}

/* Inline field editing styles */
.editable-field-value {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 6px;
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.2s;
}

.editable-field-value:hover {
  background: #f0f7ff;
}

.editable-field-value .edit-field-icon {
  opacity: 0;
  width: 11px;
  height: 11px;
  color: #4a90e2;
  transition: opacity 0.2s;
}

.editable-field-value:hover .edit-field-icon {
  opacity: 1;
}

.empty-field-value {
  color: #999;
  font-style: italic;
  font-size: 12px;
}

.inline-edit-field {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.inline-input-field {
  padding: 3px 6px;
  border: 2px solid #4a90e2;
  border-radius: 4px;
  font-size: 13px;
  min-width: 80px;
  outline: none;
}

.inline-field-actions {
  display: flex;
  gap: 2px;
}

.inline-save-field,
.inline-cancel-field {
  padding: 3px 6px;
  border: none;
  border-radius: 3px;
  cursor: pointer;
  font-size: 12px;
  font-weight: bold;
  transition: background 0.2s;
}

.inline-save-field svg,
.inline-cancel-field svg {
  width: 13px;
  height: 13px;
}

.inline-save-field {
  background: #28a745;
  color: white;
}

.inline-save-field:hover {
  background: #218838;
}

.inline-save-field:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.inline-cancel-field {
  background: #6c757d;
  color: white;
}

.inline-cancel-field:hover {
  background: #5a6268;
}

.inline-cancel-field:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Card header editable fields */
.card-name-part {
  font-weight: 600;
}

/* Contact inline grid for expanded view - compact version */
.contact-inline-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px 20px;
  margin-top: 4px;
}

.contact-inline-row {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  padding: 4px 0;
}

.contact-inline-row strong {
  min-width: 75px;
  font-size: 11px;
  color: #6b7280;
  font-weight: 600;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.contact-inline-row strong svg,
.info-icon svg {
  width: 13px;
  height: 13px;
  flex-shrink: 0;
}

.contact-inline-row .contact-link {
  color: #4a90e2;
  text-decoration: none;
  font-size: 12px;
  word-break: break-all;
}

.contact-inline-row .contact-link:hover {
  text-decoration: underline;
}

.contact-inline-row .editable-field-value {
  font-size: 12px;
}

.contact-inline-row .empty-field-value {
  font-size: 11px;
}

/* Compact detail panel for contacts */
.detail-panel.contact-panel {
  padding: 12px 14px;
}

.detail-panel.contact-panel h4 {
  margin: 0 0 8px 0;
  font-size: 12px;
  color: #6b7280;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

@media (max-width: 768px) {
  .contact-inline-grid {
    grid-template-columns: 1fr;
  }
}

/* ===== Attachments Styles ===== */
.attachments-panel {
  grid-column: 1 / -1;
}

.attachments-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 10px;
}

.attachment-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  transition: all 0.2s;
}

.attachment-item:hover {
  background: #e9ecef;
  border-color: #adb5bd;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.attachment-icon {
  font-size: 24px;
  flex-shrink: 0;
}

.attachment-info {
  flex: 1 1;
  min-width: 0;
}

.attachment-name {
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 4px;
  word-break: break-word;
}

.attachment-size {
  font-size: 12px;
  color: #6c757d;
}

.attachment-actions {
  display: flex;
  gap: 8px;
}

.attachment-download-btn,
.attachment-preview-btn {
  padding: 6px 12px;
  border: none;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
}

.attachment-download-btn {
  background: #28a745;
  color: white;
}

.attachment-download-btn:hover {
  background: #218838;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0,0,0,0.2);
}

.attachment-preview-btn {
  background: #007bff;
  color: white;
}

.attachment-preview-btn:hover {
  background: #0056b3;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0,0,0,0.2);
}

.detail-panel h4 {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  color: #2c3e50;
  font-size: 16px;
  font-weight: 600;
}

.detail-panel h4 > svg {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}

/* Attachments Dropdown Header */
.attachments-header {
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  transition: background 0.2s;
  padding: 8px;
  margin: -8px -8px 8px -8px;
  border-radius: 4px;
}

.attachments-header:hover {
  background: #f0f0f0;
}

.attachments-header h4 {
  display: flex;
  align-items: center;
  margin: 0;
}

.dropdown-arrow {
  display: inline-block;
  margin-right: 8px;
  font-size: 12px;
  transition: transform 0.2s ease;
  color: #666;
}

.dropdown-arrow.expanded {
  transform: rotate(90deg);
}

.attachments-header h4:hover .dropdown-arrow {
  color: #007bff;
}

/* ===== Compact Attachments Styles ===== */
.attachments-section {
  margin-top: 15px;
}

.attachments-compact-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 10px;
}

.attachment-compact-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  transition: all 0.2s;
  min-height: 40px;
  max-height: 50px;
}

.attachment-compact-item:hover {
  background: #e9ecef;
  border-color: #adb5bd;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}

.attachment-compact-icon {
  flex-shrink: 0;
  width: 24px;
  text-align: center;
}

.attachment-compact-icon svg {
  width: 18px;
  height: 18px;
}

.attachment-compact-info {
  flex: 1 1;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.attachment-compact-name {
  font-weight: 500;
  color: #2c3e50;
  font-size: 13px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1 1;
  min-width: 0;
}

.attachment-compact-size {
  font-size: 11px;
  color: #6c757d;
  flex-shrink: 0;
  background: #e9ecef;
  padding: 2px 6px;
  border-radius: 3px;
  font-weight: 500;
}

.attachment-compact-actions {
  display: flex;
  gap: 4px;
  flex-shrink: 0;
}

.attachment-compact-btn {
  width: 28px;
  height: 28px;
  padding: 0;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.attachment-compact-btn.download {
  background: #28a745;
  color: white;
}

.attachment-compact-btn.download:hover {
  background: #218838;
  transform: scale(1.1);
}

.attachment-compact-btn.preview {
  background: #007bff;
  color: white;
}

.attachment-compact-btn.preview:hover {
  background: #0056b3;
  transform: scale(1.1);
}

.attachment-compact-btn:active {
  transform: scale(0.95);
}

.attachment-compact-btn svg {
  width: 15px;
  height: 15px;
}

.modal-btn,
.error-banner button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.modal-btn svg,
.error-banner button svg,
.tab-btn > svg {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

.rejection-comment-text {
  display: flex;
  align-items: flex-start;
  gap: 6px;
}

.rejection-comment-text svg {
  width: 15px;
  height: 15px;
  flex-shrink: 0;
  margin-top: 2px;
}
.transfer-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  border: 1px solid #2563eb;
  border-radius: 0.5rem;
  padding: 0.55rem 0.75rem;
  background: #eff6ff;
  color: #1d4ed8;
  font-weight: 600;
  cursor: pointer;
}

.transfer-btn:hover:not(:disabled) { background: #dbeafe; }
.transfer-btn svg { width: 1rem; height: 1rem; }

.meeting-card.transfer-open {
  position: relative;
  z-index: 20;
  overflow: visible;
}

.transfer-control {
  position: relative;
  display: inline-flex;
}

.transfer-panel {
  position: absolute;
  top: calc(100% + 10px);
  right: 50%;
  z-index: 100;
  width: min(360px, calc(100vw - 32px));
  margin: 0;
  overflow: visible;
  border: 1px solid #bfdbfe;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 8px 24px rgba(37, 99, 235, 0.1);
  transform: translateX(50%);
}

.transfer-panel::before {
  content: '';
  position: absolute;
  top: -7px;
  left: 50%;
  width: 12px;
  height: 12px;
  border-top: 1px solid #bfdbfe;
  border-left: 1px solid #bfdbfe;
  background: #eff6ff;
  transform: translateX(-50%) rotate(45deg);
}

.transfer-panel-header {
  display: flex;
  align-items: flex-start;
  gap: 9px;
  padding: 12px 14px;
  background: #eff6ff;
  color: #1e3a8a;
  border-radius: 13px 13px 0 0;
}

.transfer-panel-header > svg {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

.transfer-panel-header h3,
.transfer-panel-header p {
  margin: 0;
}

.transfer-panel-header h3 {
  font-size: 16px;
}

.transfer-panel-header p {
  margin-top: 2px;
  color: #475569;
  font-size: 12px;
}

.transfer-panel-body {
  padding: 14px;
}

.transfer-panel-body > label {
  display: block;
  margin-bottom: 6px;
  color: #334155;
  font-size: 13px;
  font-weight: 600;
}

.transfer-employee-search {
  width: 100%;
  box-sizing: border-box;
  padding: 8px 10px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  font: inherit;
}

.transfer-employee-search:focus {
  outline: none;
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12);
}

.transfer-employee-list {
  max-height: 180px;
  margin-top: 9px;
  overflow-y: auto;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
}

.transfer-employee-list button {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 8px 10px;
  border: 0;
  border-bottom: 1px solid #e2e8f0;
  background: #fff;
  color: #1e293b;
  font: inherit;
  text-align: left;
  cursor: pointer;
}

.transfer-employee-list button:last-child {
  border-bottom: 0;
}

.transfer-employee-list button:hover {
  background: #f8fafc;
}

.transfer-employee-list button.selected {
  background: #dbeafe;
  color: #1d4ed8;
  font-weight: 600;
}

.transfer-employee-list button svg {
  width: 18px;
  height: 18px;
}

.transfer-empty {
  margin: 14px 0 0;
  color: #64748b;
  text-align: center;
}

.transfer-panel-hint {
  margin: 10px 0 0;
  color: #64748b;
  font-size: 13px;
}

.transfer-panel-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 10px 14px;
  border-top: 1px solid #e2e8f0;
  border-radius: 0 0 13px 13px;
  background: #f8fafc;
}
`, "",{"version":3,"sources":["webpack://./src/pages/css/AssignedRequests.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA,6BAA6B;AAC7B;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,sCAAsC;EACtC,kCAAkC;EAClC,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA,mBAAmB,0BAA0B,EAAE;AAC/C,mBAAmB,0BAA0B,EAAE;AAC/C,mBAAmB,0BAA0B,EAAE;AAC/C,mBAAmB,0BAA0B,EAAE;;AAE/C;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,eAAe;AACjB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,6BAA6B;AAC7B;EACE,gBAAgB;EAChB,mBAAmB;EACnB,sCAAsC;EACtC,gBAAgB;EAChB,+CAA+C;EAC/C,yBAAyB;AAC3B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;;EAGE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA,+BAA+B;AAC/B;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,8BAA8B;AAChC;;AAEA;EACE,OAAO,UAAU,EAAE,aAAa,EAAE;EAClC,OAAO,UAAU,EAAE,kBAAkB,EAAE;AACzC;;AAEA,kDAAkD;AAClD;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;;EAEE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;EAEE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;EAC5B,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;EAC5B,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,MAAM;EACN,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA,gEAAgE;AAChE;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA,oDAAoD;AACpD;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,WAAW;EACX,iBAAiB;AACnB;;AAEA;;EAEE,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,8CAA8C;EAC9C,sBAAsB;EACtB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,4BAA4B;EAC5B,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,0BAA0B;AAC1B;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,OAAO,UAAU,EAAE;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,0CAA0C;EAC1C,+BAA+B;AACjC;;AAEA;EACE,OAAO,UAAU,EAAE,uCAAuC,EAAE;EAC5D,OAAO,UAAU,EAAE,iCAAiC,EAAE;AACxD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,iDAAiD;AACjD;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,yDAA0L;EAC1L,4BAA4B;EAC5B,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA,2BAA2B;AAC3B;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,kCAAkC;IAClC,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;IACnB,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;IACR,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,UAAU;EACZ;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF;;AAEA,gCAAgC;AAChC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,aAAa;AACf;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;;EAEE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC;EACE,gBAAgB;AAClB;;AAEA,4DAA4D;AAC5D;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA,sCAAsC;AACtC;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA,mCAAmC;AACnC;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;;EAEE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA,gCAAgC;AAChC;EACE,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,2BAA2B;EAC3B,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;EACf,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;AAChB;;AAEA,2CAA2C;AAC3C;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;;;EAGE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,wBAAwB;EACxB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA,qCAAqC,mBAAmB,EAAE;AAC1D,oBAAoB,WAAW,EAAE,YAAY,EAAE;;AAE/C;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,UAAU;EACV,YAAY;EACZ,qCAAqC;EACrC,SAAS;EACT,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,6CAA6C;EAC7C,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,8BAA8B;EAC9B,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;;EAEE,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;EACjB,SAAS;EACT,gCAAgC;EAChC,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,kBAAkB;EAClB,6BAA6B;EAC7B,4BAA4B;EAC5B,mBAAmB;AACrB","sourcesContent":["/* ===== Page Layout ===== */\n.my-meetings-page {\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.page-header {\n  margin-bottom: 28px;\n}\n\n.header-top {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  flex-wrap: wrap;\n}\n\n.page-header h2 {\n  font-size: 28px;\n  color: #1a1a2e;\n  margin: 0;\n  font-weight: 700;\n}\n\n.total-badge {\n  background: #e8f0fe;\n  color: #0066cc;\n  font-size: 13px;\n  font-weight: 600;\n  padding: 4px 12px;\n  border-radius: 20px;\n}\n\n.page-header p {\n  color: #6b7280;\n  margin: 6px 0 0 0;\n  font-size: 15px;\n}\n\n/* ===== Error Banner ===== */\n.error-banner {\n  background: #fef2f2;\n  border: 1px solid #fecaca;\n  color: #b91c1c;\n  padding: 14px 18px;\n  border-radius: 10px;\n  margin-bottom: 24px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 14px;\n}\n\n.error-banner button {\n  background: none;\n  border: none;\n  color: #b91c1c;\n  cursor: pointer;\n  font-size: 18px;\n  padding: 0 4px;\n}\n\n/* ===== Summary Row ===== */\n.summary-row {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 16px;\n  margin-bottom: 28px;\n}\n\n.summary-card {\n  background: #fff;\n  border-radius: 12px;\n  padding: 20px 24px;\n  box-shadow: 0 1px 4px rgba(0,0,0,0.06);\n  border-left: 4px solid transparent;\n  transition: transform 0.15s, box-shadow 0.15s;\n}\n\n.summary-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0,0,0,0.1);\n}\n\n.summary-active  { border-left-color: #0066cc; }\n.summary-success { border-left-color: #16a34a; }\n.summary-fail    { border-left-color: #dc2626; }\n.summary-spam    { border-left-color: #7c3aed; }\n\n.summary-num {\n  font-size: 32px;\n  font-weight: 700;\n  color: #1a1a2e;\n  line-height: 1;\n}\n\n.summary-label {\n  font-size: 13px;\n  color: #6b7280;\n  margin-top: 4px;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n/* ===== Tabs ===== */\n.tabs {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 24px;\n  border-bottom: 2px solid #e5e7eb;\n  padding-bottom: 0;\n}\n\n.tab-btn {\n  padding: 12px 20px;\n  background: transparent;\n  border: none;\n  border-bottom: 3px solid transparent;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n  color: #6b7280;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: -2px;\n}\n\n.tab-btn:hover {\n  color: #374151;\n  border-bottom-color: #d1d5db;\n}\n\n.tab-btn.active {\n  color: #0066cc;\n  border-bottom-color: #0066cc;\n}\n\n.tab-count {\n  background: #e5e7eb;\n  color: #374151;\n  font-size: 12px;\n  font-weight: 600;\n  padding: 2px 8px;\n  border-radius: 10px;\n  min-width: 20px;\n  text-align: center;\n}\n\n.tab-btn.active .tab-count {\n  background: #dbeafe;\n  color: #0066cc;\n}\n\n.tab-btn.tab-spam.active {\n  color: #7c3aed;\n  border-bottom-color: #7c3aed;\n}\n\n.tab-btn.tab-spam.active .tab-count {\n  background: #ede9fe;\n  color: #6d28d9;\n}\n\n/* ===== Loading ===== */\n.loading-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n  padding: 60px 20px;\n  color: #6b7280;\n  font-size: 15px;\n}\n\n.loading-spinner-ring {\n  width: 36px;\n  height: 36px;\n  border: 3px solid #e5e7eb;\n  border-top-color: #0066cc;\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n/* ===== Empty State ===== */\n.empty-state {\n  text-align: center;\n  padding: 72px 20px;\n  background: #f9fafb;\n  border-radius: 16px;\n  border: 2px dashed #e5e7eb;\n}\n\n.empty-icon {\n  margin-bottom: 16px;\n}\n\n.empty-icon svg {\n  width: 52px;\n  height: 52px;\n}\n\n.empty-state h3 {\n  margin: 0 0 8px 0;\n  color: #1a1a2e;\n  font-size: 18px;\n}\n\n.empty-state p {\n  color: #6b7280;\n  margin: 0;\n  font-size: 14px;\n}\n\n/* ===== Card List ===== */\n.cards-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n/* ===== Meeting Card ===== */\n.meeting-card {\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.05);\n  overflow: hidden;\n  transition: box-shadow 0.2s, border-color 0.15s;\n  border: 1px solid #e5e7eb;\n}\n\n.meeting-card:hover {\n  box-shadow: 0 3px 12px rgba(0,0,0,0.07);\n}\n\n.meeting-card.card-open {\n  border-color: #93c5fd;\n  box-shadow: 0 2px 12px rgba(0,102,204,0.1);\n}\n\n.meeting-card.card-completed {\n  opacity: 0.75;\n  border-color: #d1d5db;\n}\n\n.meeting-card.card-spam {\n  border-color: #c4b5fd;\n  background: #faf5ff;\n}\n\n/* Clickable area */\n.card-clickable {\n  cursor: pointer;\n  transition: background 0.1s;\n}\n\n.card-clickable:hover {\n  background: #f9fafb;\n}\n\n/* Card Header */\n.card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 18px 4px;\n}\n\n.card-header-left {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n}\n\n.expand-arrow {\n  color: #9ca3af;\n  font-size: 12px;\n  flex-shrink: 0;\n  width: 14px;\n}\n\n.expand-arrow svg {\n  width: 14px;\n  height: 14px;\n}\n\n.card-id {\n  font-weight: 700;\n  color: #0066cc;\n  font-size: 14px;\n  flex-shrink: 0;\n}\n\n.card-name {\n  font-weight: 600;\n  color: #1a1a2e;\n  font-size: 14px;\n  white-space: nowrap;\n}\n\n.card-subject-inline {\n  color: #6b7280;\n  font-size: 13px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  min-width: 0;\n}\n\n.card-header-right {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-shrink: 0;\n}\n\n.card-date {\n  color: #9ca3af;\n  font-size: 12px;\n}\n\n.card-assigned-date {\n  color: #6366f1;\n  font-size: 12px;\n  font-weight: 500;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.card-assigned-date svg,\n.status-badge svg,\n.chip svg {\n  width: 14px;\n  height: 14px;\n  flex-shrink: 0;\n}\n\n.status-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 5px 14px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.3px;\n}\n\n.badge-not_started {\n  background: #f0f1f2;\n  color: #6c757d;\n}\n\n.badge-in_progress {\n  background: #dbeafe;\n  color: #1d4ed8;\n}\n\n.badge-completed {\n  background: #dcfce7;\n  color: #16a34a;\n}\n\n.badge-spam {\n  background: #ede9fe;\n  color: #6d28d9;\n}\n\n/* Contact details (in expanded panel) */\n.contact-details-grid {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px 24px;\n}\n\n.contact-link {\n  color: #0066cc;\n  text-decoration: none;\n  font-size: 13px;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  transition: color 0.15s;\n}\n\n.contact-link:hover {\n  color: #004999;\n  text-decoration: underline;\n}\n\n.contact-location {\n  font-size: 13px;\n  color: #6b7280;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.contact-icon {\n  font-size: 14px;\n  width: 18px;\n  text-align: center;\n  flex-shrink: 0;\n}\n\n.expanded-contact-row {\n  margin-bottom: 0;\n}\n\n/* Chips Row */\n.card-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  padding: 4px 18px 12px 42px;\n}\n\n.chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 12px;\n  border-radius: 16px;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.chip-success {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.chip-danger {\n  background: #fef2f2;\n  color: #991b1b;\n}\n\n.chip-neutral {\n  background: #f3f4f6;\n  color: #6b7280;\n}\n\n.chip-amount {\n  background: #ecfdf5;\n  color: #047857;\n  font-weight: 600;\n}\n\n.chip-rejection {\n  background: #fef3c7;\n  color: #92400e;\n}\n\n.chip-notes {\n  background: #ede9fe;\n  color: #5b21b6;\n}\n\n.chip-clickable {\n  cursor: pointer;\n  transition: opacity 0.15s;\n}\n\n.chip-clickable:hover {\n  opacity: 0.8;\n}\n\n/* ===== Expanded Panel ===== */\n.card-expanded {\n  border-top: 1px solid #e5e7eb;\n  background: #f9fafb;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  animation: expandIn 0.15s ease;\n}\n\n@keyframes expandIn {\n  from { opacity: 0; max-height: 0; }\n  to   { opacity: 1; max-height: 2000px; }\n}\n\n/* Actions row (Contacted / Deal / Order Status) */\n.expanded-actions-row {\n  display: flex;\n  gap: 24px;\n  flex-wrap: nowrap;\n  padding: 16px 20px;\n  background: #fff;\n  border-radius: 12px;\n  border: 1px solid #e5e7eb;\n}\n\n.action-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  min-width: 140px;\n}\n\n.action-group-wide {\n  flex: 1 0 auto;\n  min-width: 370px;\n}\n\n.action-group-return {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  min-width: auto;\n}\n\n.lead-actions-group {\n  min-width: max-content;\n}\n\n.lead-actions-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: nowrap;\n}\n\n.return-btn {\n  padding: 7px 18px;\n  border: 1px solid #f59e0b;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.15s;\n  background: #fffbeb;\n  color: #92400e;\n  white-space: nowrap;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.return-btn:hover:not(:disabled) {\n  background: #fef3c7;\n  border-color: #d97706;\n}\n\n.return-btn:disabled {\n  opacity: 0.5;\n  cursor: default;\n}\n\n.reactivate-btn {\n  padding: 7px 18px;\n  border: 1px solid #3b82f6;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.15s;\n  background: #eff6ff;\n  color: #1e40af;\n  white-space: nowrap;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.reactivate-btn:hover:not(:disabled) {\n  background: #dbeafe;\n  border-color: #2563eb;\n}\n\n.reactivate-btn:disabled {\n  opacity: 0.5;\n  cursor: default;\n}\n\n.spam-btn,\n.restore-spam-btn {\n  padding: 7px 18px;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.15s;\n  white-space: nowrap;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.spam-btn {\n  border: 1px solid #8b5cf6;\n  background: #faf5ff;\n  color: #6d28d9;\n}\n\n.spam-btn:hover:not(:disabled) {\n  background: #ede9fe;\n  border-color: #7c3aed;\n}\n\n.restore-spam-btn {\n  border: 1px solid #3b82f6;\n  background: #eff6ff;\n  color: #1e40af;\n}\n\n.restore-spam-btn:hover:not(:disabled) {\n  background: #dbeafe;\n  border-color: #2563eb;\n}\n\n.spam-btn:disabled,\n.restore-spam-btn:disabled {\n  opacity: 0.5;\n  cursor: default;\n}\n\n.edit-rejection-btn {\n  background: none;\n  border: none;\n  color: #991b1b;\n  font-size: 12px;\n  cursor: pointer;\n  margin-left: 8px;\n  padding: 2px 6px;\n  border-radius: 4px;\n  transition: background 0.15s;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.edit-rejection-btn:hover {\n  background: #fecaca;\n}\n\n.edit-deal-amount-btn {\n  background: none;\n  border: none;\n  color: #166534;\n  font-size: 12px;\n  cursor: pointer;\n  margin-left: 8px;\n  padding: 2px 6px;\n  border-radius: 4px;\n  transition: background 0.15s;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.edit-rejection-btn svg,\n.edit-deal-amount-btn svg {\n  width: 12px;\n  height: 12px;\n}\n\n.edit-deal-amount-btn:hover {\n  background: #bbf7d0;\n}\n\n.action-label {\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: #6b7280;\n}\n\n/* Toggles (Yes/No) */\n.toggle-group {\n  display: flex;\n  gap: 0;\n  border-radius: 8px;\n  overflow: hidden;\n  border: 1px solid #d1d5db;\n  width: fit-content;\n}\n\n.toggle-btn {\n  padding: 7px 18px;\n  border: none;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.15s;\n  background: #fff;\n  color: #6b7280;\n}\n\n.toggle-btn + .toggle-btn {\n  border-left: 1px solid #d1d5db;\n}\n\n.toggle-yes.active {\n  background: #16a34a;\n  color: #fff;\n}\n\n.toggle-no.active {\n  background: #dc2626;\n  color: #fff;\n}\n\n.toggle-btn:hover:not(:disabled):not(.active) {\n  background: #f3f4f6;\n}\n\n.toggle-btn:disabled {\n  opacity: 0.5;\n  cursor: default;\n}\n\n/* Order Status Pills */\n.order-status-picker {\n  position: relative;\n}\n\n.order-pills {\n  display: flex;\n  gap: 8px;\n  flex-wrap: nowrap;\n}\n\n.order-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 7px 16px;\n  border: 1px solid #d1d5db;\n  border-radius: 20px;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.15s;\n  background: #fff;\n  color: #6b7280;\n}\n\n.pill-icon {\n  width: 12px;\n  height: 12px;\n}\n\n.order-pill:hover:not(:disabled):not(.active) {\n  background: #f3f4f6;\n  border-color: #9ca3af;\n}\n\n.order-pill.active.pill-not_started {\n  background: #6c757d;\n  border-color: #6c757d;\n  color: #fff;\n}\n\n.order-pill.active.pill-in_progress {\n  background: #0066cc;\n  border-color: #0066cc;\n  color: #fff;\n}\n\n.order-pill.active.pill-completed {\n  background: #16a34a;\n  border-color: #16a34a;\n  color: #fff;\n}\n\n.order-pill:disabled {\n  opacity: 0.5;\n  cursor: default;\n}\n\n/* Validation toast */\n.validation-toast {\n  margin-top: 10px;\n  background: #dc2626;\n  color: #fff;\n  padding: 8px 14px;\n  border-radius: 8px;\n  font-size: 12px;\n  line-height: 1.4;\n  animation: slideDown 0.2s ease;\n}\n\n@keyframes slideDown {\n  from { opacity: 0; transform: translateY(-6px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n/* Row 2: Contact Info (full width, same as actions row above) */\n.contact-sidebar-row {\n  margin-bottom: 20px;\n}\n\n.contact-sidebar-row .detail-panel {\n  width: 100%;\n}\n\n/* Row 3: Details row (Message + Notes, 2 columns) */\n.expanded-details-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 20px;\n}\n\n@media (max-width: 768px) {\n  .expanded-details-row {\n    grid-template-columns: 1fr;\n  }\n}\n\n.detail-panel {\n  background: #fff;\n  border-radius: 12px;\n  border: 1px solid #e5e7eb;\n  padding: 20px;\n}\n\n.detail-panel h4 {\n  margin: 0 0 14px 0;\n  color: #1a1a2e;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.message-full {\n  background: #f9fafb;\n  padding: 16px;\n  border-radius: 10px;\n  border: 1px solid #e5e7eb;\n  min-height: 80px;\n  white-space: pre-wrap;\n  word-break: break-word;\n  font-size: 14px;\n  line-height: 1.6;\n  color: #374151;\n}\n\n.message-full table {\n  border-collapse: collapse;\n  margin: 10px 0;\n  width: auto;\n  background: white;\n}\n\n.message-full table th,\n.message-full table td {\n  border: 1px solid #ddd;\n  padding: 8px 12px;\n  text-align: left;\n}\n\n.message-full table th {\n  background-color: #f5f5f5;\n  font-weight: 600;\n  color: #333;\n}\n\n.message-full table tr:nth-child(even) {\n  background-color: #fafafa;\n}\n\n.notes-textarea {\n  width: 100%;\n  min-height: 140px;\n  padding: 14px;\n  border: 1px solid #d1d5db;\n  border-radius: 10px;\n  font-size: 14px;\n  font-family: inherit;\n  resize: vertical;\n  transition: border-color 0.2s, box-shadow 0.2s;\n  box-sizing: border-box;\n  color: #374151;\n  line-height: 1.6;\n}\n\n.notes-textarea:focus {\n  outline: none;\n  border-color: #0066cc;\n  box-shadow: 0 0 0 3px rgba(0,102,204,0.1);\n}\n\n.notes-actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-top: 12px;\n}\n\n.save-notes-btn {\n  padding: 9px 20px;\n  background: #16a34a;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.15s;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.save-notes-btn svg {\n  width: 15px;\n  height: 15px;\n}\n\n.save-notes-btn:hover:not(:disabled) {\n  background: #15803d;\n}\n\n.save-notes-btn:disabled {\n  background: #d1d5db;\n  color: #9ca3af;\n  cursor: not-allowed;\n}\n\n/* Extra panels (rejection / deal amount) */\n.expanded-extra-row {\n  display: flex;\n  gap: 20px;\n  flex-wrap: wrap;\n}\n\n.extra-panel {\n  background: #fff;\n  border-radius: 12px;\n  border: 1px solid #e5e7eb;\n  padding: 20px;\n  flex: 1;\n  min-width: 240px;\n}\n\n.extra-panel h4 {\n  margin: 0 0 12px 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: #1a1a2e;\n}\n\n.rejection-panel {\n  border-color: #fecaca;\n  background: #fffbfb;\n}\n\n.rejection-info-box {\n  background: #fef2f2;\n  padding: 14px;\n  border-radius: 10px;\n  border: 1px solid #fecaca;\n}\n\n/* Email source info box */\n.email-source-info-box {\n  background: #eff6ff;\n  padding: 10px 12px;\n  border-radius: 8px;\n  border: 1px solid #bfdbfe;\n  margin-bottom: 12px;\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  font-size: 12px;\n  line-height: 1.5;\n}\n\n.email-source-info-box .info-icon {\n  font-size: 14px;\n  flex-shrink: 0;\n}\n\n.email-source-info-box .info-text {\n  color: #1e40af;\n  font-size: 11px;\n}\n\n.rejection-label {\n  color: #991b1b;\n  font-weight: 500;\n  font-size: 14px;\n}\n\n.rejection-comment-text {\n  margin-top: 8px;\n  font-size: 13px;\n  color: #6b7280;\n  font-style: italic;\n  line-height: 1.4;\n}\n\n.deal-panel {\n  border-color: #bbf7d0;\n  background: #f0fdf4;\n}\n\n.deal-amount-display {\n  font-size: 22px;\n  font-weight: 700;\n  color: #16a34a;\n  background: #dcfce7;\n  padding: 10px 20px;\n  border-radius: 10px;\n  display: inline-block;\n}\n\n/* ===== Modals ===== */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.4);\n  backdrop-filter: blur(4px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 2000;\n  animation: fadeIn 0.15s ease;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to   { opacity: 1; }\n}\n\n.modal-content {\n  background: white;\n  padding: 36px;\n  border-radius: 16px;\n  max-width: 480px;\n  width: 92%;\n  text-align: center;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);\n  animation: modalSlide 0.2s ease;\n}\n\n@keyframes modalSlide {\n  from { opacity: 0; transform: translateY(16px) scale(0.97); }\n  to   { opacity: 1; transform: translateY(0) scale(1); }\n}\n\n.modal-icon {\n  margin-bottom: 16px;\n}\n\n.modal-icon svg {\n  width: 48px;\n  height: 48px;\n}\n\n.modal-content h3 {\n  margin: 0 0 12px 0;\n  color: #1a1a2e;\n  font-size: 20px;\n  font-weight: 600;\n}\n\n.modal-content p {\n  margin: 0 0 20px 0;\n  color: #6b7280;\n  font-size: 14px;\n}\n\n.rejection-options {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  text-align: left;\n  width: 100%;\n  margin-bottom: 16px;\n}\n\n.rejection-option {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  padding: 12px 16px;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  box-sizing: border-box;\n  cursor: pointer;\n  font-size: 14px;\n  line-height: 1.4;\n  transition: all 0.15s;\n}\n\n.rejection-option:hover {\n  background: #f9fafb;\n}\n\n.rejection-option.selected {\n  border-color: #dc2626;\n  background: #fef2f2;\n}\n\n.my-meetings-page .rejection-option input[type=\"radio\"] {\n  flex: 0 0 16px;\n  width: 16px;\n  height: 16px;\n  padding: 0;\n  margin: 0;\n  border-radius: 50%;\n  accent-color: #dc2626;\n  cursor: pointer;\n}\n\n.rejection-comment-input {\n  width: 100%;\n  min-height: 80px;\n  padding: 12px;\n  border: 1px solid #d1d5db;\n  border-radius: 10px;\n  font-size: 14px;\n  font-family: inherit;\n  resize: vertical;\n  box-sizing: border-box;\n  margin-bottom: 16px;\n}\n\n.rejection-comment-input:focus {\n  outline: none;\n  border-color: #dc2626;\n  box-shadow: 0 0 0 3px rgba(220,38,38,0.1);\n}\n\n.modal-actions {\n  display: flex;\n  gap: 12px;\n  justify-content: center;\n  margin-top: 8px;\n}\n\n.modal-btn {\n  padding: 11px 28px;\n  border-radius: 10px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.15s;\n  border: none;\n}\n\n.modal-btn.cancel {\n  background: #f3f4f6;\n  color: #6b7280;\n  border: 1px solid #e5e7eb;\n}\n\n.modal-btn.cancel:hover {\n  background: #e5e7eb;\n}\n\n.modal-btn.confirm {\n  background: #dc2626;\n  color: white;\n}\n\n.modal-btn.confirm:hover {\n  background: #b91c1c;\n}\n\n.modal-btn.confirm.confirm-green {\n  background: #16a34a;\n}\n\n.modal-btn.confirm.confirm-green:hover {\n  background: #15803d;\n}\n\n.modal-btn.confirm.confirm-orange {\n  background: #d97706;\n}\n\n.modal-btn.confirm.confirm-orange:hover {\n  background: #b45309;\n}\n\n.modal-btn.confirm.confirm-blue {\n  background: #2563eb;\n}\n\n.modal-btn.confirm.confirm-blue:hover {\n  background: #1d4ed8;\n}\n\n.modal-btn.confirm.confirm-spam {\n  background: #7c3aed;\n}\n\n.modal-btn.confirm.confirm-spam:hover {\n  background: #6d28d9;\n}\n\n.modal-hint {\n  font-size: 13px;\n  color: #9ca3af;\n  margin: -12px 0 12px 0;\n}\n\n.modal-btn.confirm:disabled {\n  background: #d1d5db;\n  color: #9ca3af;\n  cursor: not-allowed;\n}\n\n.deal-amount-input-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  justify-content: center;\n  margin: 20px 0;\n}\n\n.deal-amount-input {\n  padding: 12px 18px;\n  border: 2px solid #d1d5db;\n  border-radius: 10px;\n  font-size: 20px;\n  width: 200px;\n  text-align: right;\n  transition: border-color 0.15s;\n}\n\n.deal-amount-input:focus {\n  outline: none;\n  border-color: #16a34a;\n  box-shadow: 0 0 0 3px rgba(22,163,74,0.1);\n}\n\n.deal-amount-currency {\n  font-size: 18px;\n  font-weight: 600;\n  color: #6b7280;\n}\n\n/* ===== Reactivate Modal Enhanced Styles ===== */\n.modal-content-wide {\n  max-width: 520px;\n}\n\n.reactivate-edit-section {\n  text-align: left;\n  background: #f8fafc;\n  border-radius: 12px;\n  padding: 16px 20px;\n  margin: 16px 0;\n  border: 1px solid #e2e8f0;\n}\n\n.reactivate-edit-label {\n  display: block;\n  font-size: 13px;\n  font-weight: 600;\n  color: #475569;\n  margin-bottom: 10px;\n}\n\n.reactivate-edit-section .deal-amount-input-wrapper {\n  justify-content: flex-start;\n  margin: 0;\n}\n\n.rejection-reason-select-wrapper {\n  position: relative;\n}\n\n.rejection-reason-select {\n  width: 100%;\n  padding: 12px 16px;\n  border: 1px solid #d1d5db;\n  border-radius: 10px;\n  font-size: 14px;\n  font-family: inherit;\n  background: white;\n  cursor: pointer;\n  appearance: none;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%236b7280' d='M6 8L1 3h10z'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 14px center;\n}\n\n.rejection-reason-select:focus {\n  outline: none;\n  border-color: #dc2626;\n  box-shadow: 0 0 0 3px rgba(220,38,38,0.1);\n}\n\n.rejection-comment-wrapper {\n  margin-top: 12px;\n}\n\n.rejection-comment-textarea {\n  width: 100%;\n  min-height: 80px;\n  padding: 12px;\n  border: 1px solid #d1d5db;\n  border-radius: 10px;\n  font-size: 14px;\n  font-family: inherit;\n  resize: vertical;\n  box-sizing: border-box;\n}\n\n.rejection-comment-textarea:focus {\n  outline: none;\n  border-color: #dc2626;\n  box-shadow: 0 0 0 3px rgba(220,38,38,0.1);\n}\n\n/* ===== Responsive ===== */\n@media (max-width: 768px) {\n  .my-meetings-page {\n    padding: 12px;\n  }\n\n  .page-header h2 {\n    font-size: 22px;\n  }\n\n  .summary-row {\n    grid-template-columns: 1fr;\n    gap: 10px;\n  }\n\n  .summary-card {\n    padding: 14px 18px;\n  }\n\n  .summary-num {\n    font-size: 24px;\n  }\n\n  .tabs {\n    flex-direction: column;\n    gap: 4px;\n    border-bottom: none;\n  }\n\n  .tab-btn {\n    border-bottom: none;\n    border-left: 3px solid transparent;\n    border-radius: 8px;\n    margin-bottom: 0;\n    padding: 10px 16px;\n  }\n\n  .tab-btn.active {\n    background: #eff6ff;\n    border-left-color: #0066cc;\n  }\n\n  .tab-btn.tab-spam.active {\n    background: #faf5ff;\n    border-left-color: #7c3aed;\n  }\n\n  .card-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n    padding: 12px 14px 4px;\n  }\n\n  .card-header-left {\n    flex-wrap: wrap;\n  }\n\n  .card-subject-inline {\n    display: none;\n  }\n\n  .card-chips {\n    padding: 4px 14px 10px 14px;\n  }\n\n  .card-expanded {\n    padding: 18px;\n  }\n\n  .expanded-actions-row {\n    flex-direction: column;\n    gap: 16px;\n    padding: 14px 16px;\n  }\n\n  .action-group-wide {\n    min-width: unset;\n  }\n\n  .expanded-details-row {\n    grid-template-columns: 1fr;\n  }\n\n  .expanded-extra-row {\n    flex-direction: column;\n  }\n\n  .extra-panel {\n    min-width: unset;\n  }\n\n  .modal-content {\n    padding: 24px;\n    width: 95%;\n  }\n}\n\n@media (max-width: 480px) {\n  .order-pills {\n    flex-direction: column;\n  }\n\n  .order-pill {\n    text-align: center;\n    justify-content: center;\n  }\n\n  .toggle-btn {\n    padding: 7px 14px;\n    font-size: 12px;\n  }\n}\n\n/* Inline field editing styles */\n.editable-field-value {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 6px;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.editable-field-value:hover {\n  background: #f0f7ff;\n}\n\n.editable-field-value .edit-field-icon {\n  opacity: 0;\n  width: 11px;\n  height: 11px;\n  color: #4a90e2;\n  transition: opacity 0.2s;\n}\n\n.editable-field-value:hover .edit-field-icon {\n  opacity: 1;\n}\n\n.empty-field-value {\n  color: #999;\n  font-style: italic;\n  font-size: 12px;\n}\n\n.inline-edit-field {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.inline-input-field {\n  padding: 3px 6px;\n  border: 2px solid #4a90e2;\n  border-radius: 4px;\n  font-size: 13px;\n  min-width: 80px;\n  outline: none;\n}\n\n.inline-field-actions {\n  display: flex;\n  gap: 2px;\n}\n\n.inline-save-field,\n.inline-cancel-field {\n  padding: 3px 6px;\n  border: none;\n  border-radius: 3px;\n  cursor: pointer;\n  font-size: 12px;\n  font-weight: bold;\n  transition: background 0.2s;\n}\n\n.inline-save-field svg,\n.inline-cancel-field svg {\n  width: 13px;\n  height: 13px;\n}\n\n.inline-save-field {\n  background: #28a745;\n  color: white;\n}\n\n.inline-save-field:hover {\n  background: #218838;\n}\n\n.inline-save-field:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.inline-cancel-field {\n  background: #6c757d;\n  color: white;\n}\n\n.inline-cancel-field:hover {\n  background: #5a6268;\n}\n\n.inline-cancel-field:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Card header editable fields */\n.card-name-part {\n  font-weight: 600;\n}\n\n/* Contact inline grid for expanded view - compact version */\n.contact-inline-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px 20px;\n  margin-top: 4px;\n}\n\n.contact-inline-row {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  padding: 4px 0;\n}\n\n.contact-inline-row strong {\n  min-width: 75px;\n  font-size: 11px;\n  color: #6b7280;\n  font-weight: 600;\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.contact-inline-row strong svg,\n.info-icon svg {\n  width: 13px;\n  height: 13px;\n  flex-shrink: 0;\n}\n\n.contact-inline-row .contact-link {\n  color: #4a90e2;\n  text-decoration: none;\n  font-size: 12px;\n  word-break: break-all;\n}\n\n.contact-inline-row .contact-link:hover {\n  text-decoration: underline;\n}\n\n.contact-inline-row .editable-field-value {\n  font-size: 12px;\n}\n\n.contact-inline-row .empty-field-value {\n  font-size: 11px;\n}\n\n/* Compact detail panel for contacts */\n.detail-panel.contact-panel {\n  padding: 12px 14px;\n}\n\n.detail-panel.contact-panel h4 {\n  margin: 0 0 8px 0;\n  font-size: 12px;\n  color: #6b7280;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n@media (max-width: 768px) {\n  .contact-inline-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* ===== Attachments Styles ===== */\n.attachments-panel {\n  grid-column: 1 / -1;\n}\n\n.attachments-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-top: 10px;\n}\n\n.attachment-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px;\n  background: #f8f9fa;\n  border: 1px solid #dee2e6;\n  border-radius: 6px;\n  transition: all 0.2s;\n}\n\n.attachment-item:hover {\n  background: #e9ecef;\n  border-color: #adb5bd;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n}\n\n.attachment-icon {\n  font-size: 24px;\n  flex-shrink: 0;\n}\n\n.attachment-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.attachment-name {\n  font-weight: 600;\n  color: #2c3e50;\n  margin-bottom: 4px;\n  word-break: break-word;\n}\n\n.attachment-size {\n  font-size: 12px;\n  color: #6c757d;\n}\n\n.attachment-actions {\n  display: flex;\n  gap: 8px;\n}\n\n.attachment-download-btn,\n.attachment-preview-btn {\n  padding: 6px 12px;\n  border: none;\n  border-radius: 4px;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n  white-space: nowrap;\n}\n\n.attachment-download-btn {\n  background: #28a745;\n  color: white;\n}\n\n.attachment-download-btn:hover {\n  background: #218838;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 4px rgba(0,0,0,0.2);\n}\n\n.attachment-preview-btn {\n  background: #007bff;\n  color: white;\n}\n\n.attachment-preview-btn:hover {\n  background: #0056b3;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 4px rgba(0,0,0,0.2);\n}\n\n.detail-panel h4 {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 12px;\n  color: #2c3e50;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.detail-panel h4 > svg {\n  width: 18px;\n  height: 18px;\n  flex-shrink: 0;\n}\n\n/* Attachments Dropdown Header */\n.attachments-header {\n  cursor: pointer;\n  user-select: none;\n  transition: background 0.2s;\n  padding: 8px;\n  margin: -8px -8px 8px -8px;\n  border-radius: 4px;\n}\n\n.attachments-header:hover {\n  background: #f0f0f0;\n}\n\n.attachments-header h4 {\n  display: flex;\n  align-items: center;\n  margin: 0;\n}\n\n.dropdown-arrow {\n  display: inline-block;\n  margin-right: 8px;\n  font-size: 12px;\n  transition: transform 0.2s ease;\n  color: #666;\n}\n\n.dropdown-arrow.expanded {\n  transform: rotate(90deg);\n}\n\n.attachments-header h4:hover .dropdown-arrow {\n  color: #007bff;\n}\n\n/* ===== Compact Attachments Styles ===== */\n.attachments-section {\n  margin-top: 15px;\n}\n\n.attachments-compact-list {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin-top: 10px;\n}\n\n.attachment-compact-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 12px;\n  background: #f8f9fa;\n  border: 1px solid #dee2e6;\n  border-radius: 6px;\n  transition: all 0.2s;\n  min-height: 40px;\n  max-height: 50px;\n}\n\n.attachment-compact-item:hover {\n  background: #e9ecef;\n  border-color: #adb5bd;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.1);\n}\n\n.attachment-compact-icon {\n  flex-shrink: 0;\n  width: 24px;\n  text-align: center;\n}\n\n.attachment-compact-icon svg {\n  width: 18px;\n  height: 18px;\n}\n\n.attachment-compact-info {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.attachment-compact-name {\n  font-weight: 500;\n  color: #2c3e50;\n  font-size: 13px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  flex: 1;\n  min-width: 0;\n}\n\n.attachment-compact-size {\n  font-size: 11px;\n  color: #6c757d;\n  flex-shrink: 0;\n  background: #e9ecef;\n  padding: 2px 6px;\n  border-radius: 3px;\n  font-weight: 500;\n}\n\n.attachment-compact-actions {\n  display: flex;\n  gap: 4px;\n  flex-shrink: 0;\n}\n\n.attachment-compact-btn {\n  width: 28px;\n  height: 28px;\n  padding: 0;\n  border: none;\n  border-radius: 4px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: all 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.attachment-compact-btn.download {\n  background: #28a745;\n  color: white;\n}\n\n.attachment-compact-btn.download:hover {\n  background: #218838;\n  transform: scale(1.1);\n}\n\n.attachment-compact-btn.preview {\n  background: #007bff;\n  color: white;\n}\n\n.attachment-compact-btn.preview:hover {\n  background: #0056b3;\n  transform: scale(1.1);\n}\n\n.attachment-compact-btn:active {\n  transform: scale(0.95);\n}\n\n.attachment-compact-btn svg {\n  width: 15px;\n  height: 15px;\n}\n\n.modal-btn,\n.error-banner button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n}\n\n.modal-btn svg,\n.error-banner button svg,\n.tab-btn > svg {\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n}\n\n.rejection-comment-text {\n  display: flex;\n  align-items: flex-start;\n  gap: 6px;\n}\n\n.rejection-comment-text svg {\n  width: 15px;\n  height: 15px;\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n.transfer-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.4rem;\n  border: 1px solid #2563eb;\n  border-radius: 0.5rem;\n  padding: 0.55rem 0.75rem;\n  background: #eff6ff;\n  color: #1d4ed8;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.transfer-btn:hover:not(:disabled) { background: #dbeafe; }\n.transfer-btn svg { width: 1rem; height: 1rem; }\n\n.meeting-card.transfer-open {\n  position: relative;\n  z-index: 20;\n  overflow: visible;\n}\n\n.transfer-control {\n  position: relative;\n  display: inline-flex;\n}\n\n.transfer-panel {\n  position: absolute;\n  top: calc(100% + 10px);\n  right: 50%;\n  z-index: 100;\n  width: min(360px, calc(100vw - 32px));\n  margin: 0;\n  overflow: visible;\n  border: 1px solid #bfdbfe;\n  border-radius: 14px;\n  background: #fff;\n  box-shadow: 0 8px 24px rgba(37, 99, 235, 0.1);\n  transform: translateX(50%);\n}\n\n.transfer-panel::before {\n  content: '';\n  position: absolute;\n  top: -7px;\n  left: 50%;\n  width: 12px;\n  height: 12px;\n  border-top: 1px solid #bfdbfe;\n  border-left: 1px solid #bfdbfe;\n  background: #eff6ff;\n  transform: translateX(-50%) rotate(45deg);\n}\n\n.transfer-panel-header {\n  display: flex;\n  align-items: flex-start;\n  gap: 9px;\n  padding: 12px 14px;\n  background: #eff6ff;\n  color: #1e3a8a;\n  border-radius: 13px 13px 0 0;\n}\n\n.transfer-panel-header > svg {\n  width: 20px;\n  height: 20px;\n  flex-shrink: 0;\n}\n\n.transfer-panel-header h3,\n.transfer-panel-header p {\n  margin: 0;\n}\n\n.transfer-panel-header h3 {\n  font-size: 16px;\n}\n\n.transfer-panel-header p {\n  margin-top: 2px;\n  color: #475569;\n  font-size: 12px;\n}\n\n.transfer-panel-body {\n  padding: 14px;\n}\n\n.transfer-panel-body > label {\n  display: block;\n  margin-bottom: 6px;\n  color: #334155;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.transfer-employee-search {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 8px 10px;\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  font: inherit;\n}\n\n.transfer-employee-search:focus {\n  outline: none;\n  border-color: #2563eb;\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12);\n}\n\n.transfer-employee-list {\n  max-height: 180px;\n  margin-top: 9px;\n  overflow-y: auto;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n}\n\n.transfer-employee-list button {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 8px 10px;\n  border: 0;\n  border-bottom: 1px solid #e2e8f0;\n  background: #fff;\n  color: #1e293b;\n  font: inherit;\n  text-align: left;\n  cursor: pointer;\n}\n\n.transfer-employee-list button:last-child {\n  border-bottom: 0;\n}\n\n.transfer-employee-list button:hover {\n  background: #f8fafc;\n}\n\n.transfer-employee-list button.selected {\n  background: #dbeafe;\n  color: #1d4ed8;\n  font-weight: 600;\n}\n\n.transfer-employee-list button svg {\n  width: 18px;\n  height: 18px;\n}\n\n.transfer-empty {\n  margin: 14px 0 0;\n  color: #64748b;\n  text-align: center;\n}\n\n.transfer-panel-hint {\n  margin: 10px 0 0;\n  color: #64748b;\n  font-size: 13px;\n}\n\n.transfer-panel-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  padding: 10px 14px;\n  border-top: 1px solid #e2e8f0;\n  border-radius: 0 0 13px 13px;\n  background: #f8fafc;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
